import React from 'react';
import { GatsbyImageType } from 'types/common';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import * as styles from './author-reviewer.module.scss';

type AuthorProductsProps = {
  products: {
    title: string
    image: GatsbyImageType
  }[]
};
const AuthorReviewerProducts = ({ products }: AuthorProductsProps) => (
  <div className={styles.authorCurrentlyUsing}>
    <p className={styles.currentlyUsing}>
      Currently using:
    </p>

    {products.map((product) => (
      <div className={styles.productItem}>
        {product.image && (
        <GatsbyImage
          className={styles.productImage}
          alt={product.title}
          image={getImage(product.image.localFile)!}
        />
        )}
        <p className={styles.productName}>{product.title}</p>
      </div>
    ))}
  </div>
);

export { AuthorReviewerProducts };
